import policy from "./image-policy.json";
export const imageAccept = Object.keys(policy.formats).map((ext) => "." + ext).join(",");
export const supportedImageFormats = policy.supportedFormats;
const validateImage = (file, resolution = { maxWidth: policy.maxInputPixels, maxHeight: policy.maxInputPixels }, allowedMimeTypes = Object.values(policy.formats), maxSize = policy.maxUploadBytes) => {
  return new Promise((resolve) => {
    const extension = (file.name || "").split(".").pop().toLowerCase();
    const mime = file.type === "image/jpg" ? "image/jpeg" : file.type;
    if (!allowedMimeTypes.includes(mime) || policy.formats[extension] !== mime) {
      resolve({ isValid: false, error: "Supported formats: " + policy.supportedFormats + ". Extension and MIME type must match." }); return;
    }
    if (!file.size || file.size > maxSize) {
      resolve({ isValid: false, error: "Image must be nonempty and no more than " + maxSize / 1048576 + " MB." }); return;
    }
    const url = URL.createObjectURL(file);
    const img = new Image();
    const finish = (result) => { URL.revokeObjectURL(url); resolve(result); };
    img.onload = () => {
      if (img.naturalWidth * img.naturalHeight > policy.maxInputPixels || img.naturalWidth > resolution.maxWidth || img.naturalHeight > resolution.maxHeight) {
        finish({ isValid: false, error: "Image exceeds the allowed input resolution (40 megapixels)." });
      } else finish({ isValid: true, error: null });
    };
    img.onerror = () => finish({ isValid: false, error: "Invalid image or format unsupported by this browser." });
    img.src = url;
  });
};
export default validateImage;
